import React from 'react';
import './Header.css';

function Header() {
  return (
    <header className="header">
      <div className="header-content">
        <div className="logo-section">
          <div className="logo-icon">
            <img 
              src="/logo/logo.png" 
              alt="Babylon Logo" 
              className="logo-image"
            />
            <div className="online-indicator"></div>
          </div>
          <div className="header-text">
            <h1 className="header-title">Acronym Dictionary</h1>
            <p className="header-subtitle">Babylon Group Business Intelligence</p>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;

